import apollo from 'apollo';

import { AsyncActionHandler } from 'action-handler';
import { repositionTilesMutate } from 'queries';

export default new AsyncActionHandler({
  name: 'reposition_tiles',
  handler: (tiles) => async () => {
    await apollo.mutate({
      mutation: repositionTilesMutate,
      variables: {
        input: {
          tilePositions: tiles
        }
      }
    });
  }
});
